import { modulate } from "@tldraw/utils";
import { toDomPrecision } from "../primitives/utils.mjs";
function getHtmlLayerTransform(editor) {
  const { x, y, z } = editor.getCamera();
  const offset = z >= 1 ? modulate(z, [1, 8], [0.125, 0.5], true) : modulate(z, [0.1, 1], [-2, 0.125], true);
  return `scale(${toDomPrecision(z)}) translate(${toDomPrecision(x + offset)}px,${toDomPrecision(
    y + offset
  )}px)`;
}
export {
  getHtmlLayerTransform
};
//# sourceMappingURL=getHtmlLayerTransform.mjs.map
